const CARD_SHIPPING_FEES_ROUTES = {
  path: '/card-shipping-fees',
  component: () =>
    import('@/pages/CardShippingFees/CardShippingFeesPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'card-shipping-fees.index',
      component: () =>
        import('@/pages/CardShippingFees/CardShippingFeesPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'card-shipping-fees.edit',
      component: () =>
        import('@/pages/CardShippingFees/CardShippingFeeFormPage.vue'),
    },
  ],
};

export default CARD_SHIPPING_FEES_ROUTES;
